import { render, staticRenderFns } from "./BoAddLevel.vue?vue&type=template&id=726f1eb1&"
import script from "./BoAddLevel.vue?vue&type=script&lang=js&"
export * from "./BoAddLevel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports